import request from '@/utils/request'

/**
 * 查询资产盘点信息
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryAssetInventory(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/assetInventory/queryAssetInventory',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询资产盘点商品
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryAssetInventoryProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inventory.queryAssetInventoryProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 资产盘点入库
 * @param {Object} data 入库数据
 * @returns {Promise} Promise对象
 */
export function assetInventoryInStock(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/assetInventory/assetInventoryInStock',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0 || response.status === 200) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '入库失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}